module.exports = __webpack_public_path__ + "static/media/sndvol32_302.cf19f9cc.ico";